import { Moon, Sun } from "lucide-react";
import { Button } from "@/components/ui/button.jsx";
import { useTheme } from "@/contexts/ThemeContext.jsx";

/**
 * Icon button that toggles light/dark theme.
 * @returns {JSX.Element}
 */
export default function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === "dark";

  return (
    <Button
      type='button'
      variant='outline'
      size='icon'
      className='h-9 w-9 border-border bg-background dark:bg-card text-muted-foreground hover:bg-muted dark:hover:bg-muted hover:text-foreground shadow-none'
      onClick={toggleTheme}
      aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
      title={isDark ? "Switch to light mode" : "Switch to dark mode"}>
      {isDark ? <Sun className='h-4 w-4' /> : <Moon className='h-4 w-4' />}
    </Button>
  );
}
